import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';
import { MaquinasMaestroComponent } from './maquinas-maestro/maquinas-maestro.component';
import { MaquinasMaestroModalCargaMasivaComponent } from './maquinas-maestro/modal-carga-masiva/modal-carga-masiva.component';
import { MaquinasMaestroModalAddEditComponent } from './maquinas-maestro/modal-add-edit/modal-add-edit.component';
import { MaquinasMaestroModalVerMovimientoComponent } from './maquinas-maestro/modal-ver-movimiento/modal-ver-movimiento.component';
import { MaquinasInventarioVendedorComponent } from './maquinas-inventario-vendedor/maquinas-inventario-vendedor.component';
import { MaquinasInventarioClienteComponent } from './maquinas-inventario-cliente/maquinas-inventario-cliente.component';
import { MaquinasReporteClienteComponent } from './maquinas-reporte-cliente/maquinas-reporte-cliente.component';
import { MaquinasReporteAntiguedadComponent } from './maquinas-reporte-antiguedad/maquinas-reporte-antiguedad.component';
import { MaquinasReporteUbicacionComponent } from './maquinas-reporte-ubicacion/maquinas-reporte-ubicacion.component';
import { MaquinasMaestroModalAsignarComponent } from './maquinas-maestro/modal-asignar/modal-asignar.component';
import { MaquinasMaestroModalDarDeBajaComponent } from './maquinas-maestro/modal-dar-de-baja/modal-dar-de-baja.component';

// elementos usados en scroll infinito
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [
    MaquinasMaestroComponent,
    MaquinasMaestroModalCargaMasivaComponent,
    MaquinasMaestroModalAddEditComponent,
    MaquinasMaestroModalVerMovimientoComponent,
    MaquinasMaestroModalAsignarComponent,
    MaquinasMaestroModalDarDeBajaComponent,
    MaquinasInventarioVendedorComponent,
    MaquinasInventarioClienteComponent,
    MaquinasReporteClienteComponent,
    MaquinasReporteAntiguedadComponent,
    MaquinasReporteUbicacionComponent,
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    InfiniteScrollModule
  ],
  exports: [
    MaquinasMaestroComponent,
    MaquinasInventarioVendedorComponent,
    MaquinasInventarioClienteComponent,
    MaquinasReporteClienteComponent,
    MaquinasReporteAntiguedadComponent,
    MaquinasReporteUbicacionComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class MaquinasModule { }
